import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { ActivatedRoute, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';

import {
  SnackBarMessage,
} from 'src/app/shared/models/index';

import { HttpErrorResponse } from '@angular/common/http';
import { BehaviorSubject, Observable, Subject, throwError } from 'rxjs';
import { ErrorSnackbarComponent } from 'src/app/components/error-snackbar/error-snackbar.component';
import { SuccessSnackbarComponent } from 'src/app/components/success-snackbar/success-snackbar.component';
import { MatDialog } from '@angular/material/dialog';
import { ApiErrorDialogComponent } from 'src/app/components/api-error-dialog/api-error-dialog.component';
import { WarningSnackbarComponent } from 'src/app/components/warning-snackbar/warning-snackbar.component';
import { FormGroup } from '@angular/forms';
import { AuthService } from '../http/auth/auth.service';

@Injectable({
  providedIn: 'root'
})
export class UtilService {

  constructor(
    private loader: NgxUiLoaderService,
    private route: ActivatedRoute,
    private router: Router,
    private _snackBar: MatSnackBar,
    public dialog: MatDialog,
    private authService: AuthService,
    @Inject(PLATFORM_ID) private platform: Object
  ) {
  }

  objToQueryString(obj: any): string {
    if (!obj) {
      return '';
    }

    const searchParams = new URLSearchParams();
    const params = obj;
    Object.keys(params).forEach((key) => searchParams.append(key, params[key]));

    return searchParams.toString();
  }

  getToken() {  
    if(!this.isRequestFromBrowser()){
      return ""
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('token');
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return sessionStorage.getItem('token');
    } else {
      return null;
    }
  }

  getLocalStorageItem(item:string): any {
    if(!this.isRequestFromBrowser()){
      return ""
    }
    return localStorage.getItem(item)
  }

  isAuthenticated() {
    if(!this.isRequestFromBrowser()){
      return false
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    }
    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'no'
    ) {
      return localStorage.getItem('isLogged') == 'true';
    } else {
      return false;
    }
  }



  getCookie(key: string): string {
    return ""
    //return this.cookieService.get(key);
  }

  deleteCookie(key: string): void {
    //this.cookieService.delete(key);
  }

  loggedUserDetails() {

    if(!this.isRequestFromBrowser()){
      return {}
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return JSON.parse(localStorage.getItem('user_details') || '{}');
    }
    if (localStorage.getItem('remember_me')) {
      return JSON.parse(sessionStorage.getItem('user_details') || '{}');
    } else {
      return null;
    }
  }

  setLoggedUserDetails(object: any) {

    if(!this.isRequestFromBrowser()){
      return
    }

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      localStorage.setItem('user_details', JSON.stringify(object));
    }
    if (localStorage.getItem('remember_me')) {
      sessionStorage.setItem('user_details', JSON.stringify(object));
    } else {
    }
  }

  isRequestFromBrowser() {
    if (!isPlatformBrowser(this.platform)) {
      // Need for SSR setup
      return false;
    } else {
      return true;
    }
  }

  setDataInLocalStorage(
    key: any,
    value: any,
    isObjectOrArray: boolean = false
  ) {
    if (isObjectOrArray) localStorage.setItem(key, value);

    if (isObjectOrArray) localStorage.setItem(key, JSON.stringify(value));

    return true;
  }

  getDataFromLocalStorage(key: any, isObjectOrArray: boolean = false): any {
    if (!localStorage.getItem(key)) return '';

    if (isObjectOrArray) return JSON.parse(localStorage.getItem(key) || '{}');

    return localStorage.getItem(key);
  }

  addBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.add('my-class');
  }
  removeBodyClass() {
    const bodyTag = document.body;
    bodyTag.classList.remove('my-class');
  }

  showSuccessMessage(object: SnackBarMessage) {
    // this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',
      {
        duration: 3000,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //  this.removeBodyClass()
    // });
  }

  showErrorMessage(object: SnackBarMessage) {
    this.addBodyClass()
    let snackBarRef = this._snackBar.open(
      object.message,
      object.action ? object.action : 'CLOSE',

      {

        duration: undefined,
        verticalPosition: 'bottom',
        horizontalPosition: 'center',
        panelClass: ['my_snackbar'],
      }

    );
    // snackBarRef.afterDismissed().subscribe(() => {
    //   this.removeBodyClass()
    // });
  }



  updateLoginDetails(details: any) {
    // whenever talent/talent edit name and name will reflect

    if (
      localStorage.getItem('remember_me') &&
      localStorage.getItem('remember_me') == 'yes'
    ) {
      return localStorage.setItem('admin_details', JSON.stringify(details));
    }
    if (localStorage.getItem('remember_me')) {
      return sessionStorage.setItem('admin_details', JSON.stringify(details));
    }
  }

  handleError(error: HttpErrorResponse) {
    let errorMessage = '';
    if (error.error && error.error.errors) {
      // client-side error and server side
      if (Array.isArray(error.error.errors.msg)) {
        // validation error message

        if (error.error.errors.msg.length) {
          console.log(error.error.errors.msg, "(error.error.errors.msg");

          const ob = error.error.errors.msg[0];
          if (ob.msg == 'IS_EMPTY') {
            errorMessage = `${ob.param} missing`;
          } else {
            errorMessage = ob.msg;
          }
        }
      } else {
        errorMessage = error.error.errors.msg;
      }
    } else {
      // server-side error
      if (error.status == 401) {
        // Unauthorised
        // this.commonService.logout();
        this.router.navigate(['/']);
      }      
      
      if (navigator.onLine == false) {
        errorMessage = `Please check your internet connection!`;
      }
      else {

        errorMessage = `Something went wrong here`;
      }
      errorMessage = `${error.message}`;
    }
    // if (this.bulkUpload(error)) {
    //   return;
    // }
    this.showErrorMessage({
      message: errorMessage,
    });
    return throwError(errorMessage);
  }

  isStandaloneApp():boolean {
    return true
  }

  showErrorSnackbar(data: any) {
    this._snackBar.openFromComponent(ErrorSnackbarComponent, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 6000,
      data: data
    });
  }

  showSuccessSnackbar(data: any) {
    this._snackBar.openFromComponent(SuccessSnackbarComponent, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 6000,
      data: data,
      panelClass: "snackbar-marign-top"
    });
  }

  showWarningSnackbar(data: any) {
    this._snackBar.openFromComponent(WarningSnackbarComponent, {
      verticalPosition: 'top',
      horizontalPosition: 'right',
      duration: 6000,
      data: data
    });
  }

  showErrorDialog(data:any){
    if (!data.msg) return;
    this.dialog.open(ApiErrorDialogComponent, {
      width: '350px',
      height: '200px',
      data: data,
    });
  }

  storeUserDataToLocalStorageOnLogin(user: any, token: string): void {
    localStorage.setItem('remember_me', 'yes');
    localStorage.setItem('user_details', JSON.stringify(user));
    localStorage.setItem('token', token);
  }

  hasGradeMatch(grades:any[]):boolean {
    const userGradeId = JSON.parse(localStorage.getItem('user_details') || '{}')?.gradeId;
    const gradeIds = grades?.map((grade:any) => grade?.gradeDocId);
    return gradeIds?.includes(userGradeId);
  }

  getUserGrade() {
    const userGrade = JSON.parse(localStorage.getItem('user_details') || '{}')?.grade;
    return userGrade;
  }

  calcAge(dob: string): number | null {
    if (!dob) return null;
    const birth = new Date(dob);
    if (isNaN(birth.getTime())) return null;
    return Math.floor((Date.now() - birth.getTime()) / (365.25 * 24 * 60 * 60 * 1000));
  }

}
